var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showOriginal)?_c('LandingPageOriginal'):(_vm.showVersionTwo)?_c('LandingPageV2'):(_vm.showVersionThree)?_c('LandingPageV3'):_c('LandingPageV4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }